import React from "react";
import { ReactSVG } from "react-svg";

const StepperHeader = ({ step, setStep }) => {

    const handleClick = (target) => {

        // اجازه رفتن مستقیم به OTP نداریم
        if (target === 2 && step === 1) return;

        setStep(target);
    };

    return (

        <div className="p-6 pb-2">

            <div className="relative flex items-start justify-between">

                {/* progress line */}
                <div className="absolute top-5 left-[25%] right-[25%] h-[2px] flex">

                    <div className={`flex-1 rounded-full transition ${step >= 2 ? "bg-gradient-to-r from-[#543389] to-[#8b6bd9]" : "bg-slate-200"}`} />

                </div>

                {/* step 1 */}
                <div
                    className="relative flex flex-col items-center gap-2 flex-1 z-10 cursor-pointer"
                >

                    <div className={`w-10 h-10 rounded-full flex items-center justify-center border transition
                        
                        ${step === 1
                            ? "bg-gradient-to-br from-[#543389] to-[#8b6bd9] text-white shadow-lg border-none"
                            : step > 1
                                ? "bg-green-600 text-white border-none"
                                : "bg-slate-100 border-slate-200 text-slate-400"
                        }
                        
                    `}>

                        <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/mobile.svg`} className="w-5 h-5"/>
                        
                    </div>

                    <p className={`text-xs font-semibold ${step === 1 ? "text-[#543389]" : "text-green-600"}`}>
                        شماره جدید
                    </p>

                </div>

                {/* step 2 */}
                <div
                    onClick={() => handleClick(2)}
                    className="relative flex flex-col items-center gap-2 flex-1 z-10 cursor-pointer"
                >

                    <div className={`w-10 h-10 rounded-full flex items-center justify-center border transition
                        
                        ${step === 2
                            ? "bg-gradient-to-br from-[#543389] to-[#8b6bd9] text-white shadow-lg border-none"
                            : "bg-slate-100 border-slate-200 text-slate-300"
                        }
                        
                    `}>

                        <ReactSVG src={`${process.env.PUBLIC_URL}/assets/images/icons/tick.svg`} className="w-5 h-5"/>

                    </div>

                    <p className={`text-xs font-semibold ${step === 2 ? "text-[#543389]" : "text-slate-400"}`}>
                        کد تایید
                    </p>

                </div>

            </div>

        </div>

    );
};

export default StepperHeader;